import apiClient from './client';

export const productsAPI = {
  getAll: () => apiClient.get('/products/'),
  getById: (id) => apiClient.get(`/products/${id}/`),
  create: (data) => apiClient.post('/products/', data),
  update: (id, data) => apiClient.put(`/products/${id}/`, data),
  delete: (id) => apiClient.delete(`/products/${id}/`),
  getStocks: () => apiClient.get('/stocks/'),
};
